export default __webpack_public_path__ + "static/media/rebrand-square-logo-blurple.dab43bb3.svg";